export { GenericTable } from './_components/TableGeneric.vue';
export var TableStyle;
(function (TableStyle) {
    TableStyle["Resources"] = "resources";
    TableStyle["Flat"] = "flat";
    TableStyle["List"] = "list";
})(TableStyle || (TableStyle = {}));
